import { Box, Container, Grid2 as Grid, Link, Typography } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import React, { useEffect, useRef } from 'react';

const TermsAndConditions = ({ router }) => {

    const scrollToTopRef = useRef(null);
    useEffect(() => {
        scrollToTopRef.current?.scrollIntoView({ behavior: "smooth" });
    }, []);


    const navigateTo = (path) => {
        router.navigate(path); // This navigates to the specific page
    };

    return (
        <div ref={scrollToTopRef}>
            <Container maxWidth="lg" sx={{ minHeight: "1000px" }}>

                {/* BREADCRUMPS WIDGET START */}
                <Grid container spacing={1} >
                    <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{ margin: '10px' }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link underline="hover" color="inherit" onClick={() => navigateTo('/')}>
                                Home
                            </Link>
                            <Typography sx={{ color: 'text.primary' }}>Prepayment Calculator</Typography>
                        </Breadcrumbs>
                    </Grid>
                </Grid>
                {/* BREADCRUMPS WIDGET ENDS */}

                <Box sx={{ padding: '20px' }}>
                    <Typography variant="h3" gutterBottom align="center">
                        Terms and Conditions
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Last updated: January 31, 2025
                    </Typography>

                    <Typography variant="body1" paragraph>
                        These Terms and Conditions ("Terms") govern your use of FinCals.com ("we", "our", "us"). By using our financial calculator and related services, you agree to these Terms. Please read them carefully.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        1. Acceptance of Terms
                    </Typography>
                    <Typography variant="body1" paragraph>
                        By accessing or using FinCals.com, you agree to comply with these Terms and Conditions. If you do not agree to these Terms, you should not use our website or services.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        2. Use of Financial Calculator
                    </Typography>
                    <Typography variant="body1" paragraph>
                        The financial calculator available on our website is provided for informational purposes only. It is designed to assist in financial decision-making, but it does not guarantee the accuracy of the results.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        3. No Guarantee of Accuracy
                    </Typography>
                    <Typography variant="body1" paragraph>
                        While we strive to provide accurate calculations, the results from our financial calculator may not be accurate or appropriate for all users' specific situations. It is strongly recommended that you consult with a financial advisor or professional for personalized advice.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        4. User Responsibilities
                    </Typography>
                    <Typography variant="body1" paragraph>
                        You are responsible for any data you input into the calculator. The accuracy of the calculations depends on the information you provide. We are not liable for any errors in the results based on incorrect or incomplete information.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        5. Privacy and Data Collection
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We do not collect any personally identifiable information from users using our financial calculator. For more information, please review our Privacy Policy.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        6. Limitation of Liability
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Under no circumstances will FinCals.com or its affiliates be liable for any damages, losses, or expenses arising from the use of our website or the reliance on the results provided by the financial calculator.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        7. Modifications to Terms
                    </Typography>
                    <Typography variant="body1" paragraph>
                        We reserve the right to modify or update these Terms and Conditions at any time. Any changes will be posted on this page, and the date of the most recent update will be reflected at the top of the page. Continued use of the website after changes to these Terms will constitute your acceptance of the new Terms.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        8. Governing Law
                    </Typography>
                    <Typography variant="body1" paragraph>
                        These Terms and Conditions shall be governed by and construed in accordance with the laws of India. Any disputes related to these Terms shall be subject to the exclusive jurisdiction of the courts in Hyderabad.
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        9. Contact Us
                    </Typography>
                    <Typography variant="body1" paragraph>
                        If you have any questions or concerns about these Terms and Conditions, please feel free to contact us at <Link href="mailto:nandilyfe@gmail.com">nandilyfe@gmail.com</Link>.
                    </Typography>
                </Box>
            </Container>
        </div>
    );
};

export default TermsAndConditions;
